import { UPDATE_LOW_INCOME } from "./types";

export const updateLowIncome = isLowIncome => ({
  type: UPDATE_LOW_INCOME,
  payload: isLowIncome
});
